import React from "react";
import createContestIcon from "../../assets/create_contest_icon.svg";
import { CustomButton } from "../button/CustomButton";
import { useNavigate } from "react-router-dom";

export const ContestsModal = ({ openModal, closeModal }) => {
    const navigate = useNavigate()
    if (!openModal) return null;
    
    return (
        
        <div className="flex items-center justify-center">
            {/* Modal */}
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 px-4">
                <div className="bg-white rounded-lg shadow-lg max-w-[500px] w-full">
                    <div className="flex items-center justify-between mb-4  py-4 px-8 rounded-t-lg border-b border-border_color">
                        {/* Title */}
                        <span className="text-xl font-semibold text-center text-black font-grotesk">Contest Created</span>
                        {/* Close Button */}
                        <button onClick={closeModal} className="px-2 py-1 bg-transparent text-dark text-lg font-medium rounded hover:bg-accent  hover:text-secondary">
                            X
                        </button>
                    </div>
                    <div>
                        <div className="p-6 flex flex-col items-center justify-center gap-4">
                            <div className="w-20 h-20 ">
                                <img src={createContestIcon} alt="Create Contest" className="w-full h-full object-cover"/>
                            </div>
                            <p className="text-xl text-center text-dark font-medium font-grotesk">Congratulations!. <br />Contest has been created.</p>
                            <div className="w-full">
                                <CustomButton text={"Continue"} onClick={() => navigate('/admin/contests/120')} className="py-1"/>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}
